import { SectionWrapper } from '../hoc';
import { styles } from '../styles';

const Hero = () => {
  return (
    <div className="h-full">
      <div
        className={`${styles.paddingX} absolute flex flex-row items-start inset-0 top-[120px] gap-5 `}
      >
        <div className="relative flex justify-center items-center flex-col mt-5">
          <div className="rounded-full bg-[#915EFF] w-5 h-5 z-20"></div>
          <div className="violet-gradient sm:h-80 h-40 w-1"></div>
        </div>
        <div>
          <div className={`${styles.heroHeadText}`}>
            Hi, I&apos;m <span className="text-[#715eff] ">Abdullah</span>
          </div>
          <div className={`${styles.heroSubText}`}>
            <span className="{text-[#ae34ff] underline}">Exceptional</span> Web
            Developer <br className="hidden sm:block" />
            Creating <span className="z-10 bg-gradient">outstanding</span> web
            experiences.
          </div>
        </div>
      </div>
      {/* <ComputersCanvas /> */}
      {/* <div className="w-full flex items-center justify-end right-20 absolute bottom-[40vh]">
        <a href={`/#${navLinks[0].id}`}>
          <motion.div
            animate={{
              y: [0, 24, 0],
            }}
            transition={{
              duration: 1.2,
              repeat: Infinity,
              repeatType: 'loop',
            }}
            className="bg-txt-secondary rounded-full"
          >
            <div className="transorm rotate-90 p-2 flex items-center justify-center">
              <Arrow className="fill-primary stroke-primary" />
            </div>
          </motion.div>
        </a>
      </div> */}
    </div>
  );
};

export default SectionWrapper(Hero, 'hero');
